import React, { useState, useEffect } from 'react'
import Card from 'react-bootstrap/Card';
import { useSelector, useDispatch } from 'react-redux'
import { useDropzone } from 'react-dropzone'
import Dropzone from 'react-dropzone';
import { IconInfoCircleFilled, IconFileUpload } from '@tabler/icons-react';

const RegistrationPageSixComp = () => {

    const dns = window.location.hostname
    // console.log(dns)
    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const dispatch = useDispatch()
    const metodePembayaranSelected = useSelector(state => state.metodePembayaranCorporateSelected)
    const dataInputRegistration = useSelector(state => state.dataInputRegistration)

    const handleMetodePembayaran = (value) => {
        dispatch({ type: 'SET_METODE_PEMBAYARAN_CORPORATE', value: value });
    }

    const handleDrop = (file) => {
        dispatch({ type: 'SET_FILE_GL_DAN_BUKTI_BAYAR', 'value': file[0] });
    }

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ handleDrop }) // eslint-disable-line
    // console.log(dataInputRegistration.fileGLDanBuktiBayar)

    const handleShowGl = () => {
        if (dns === "localhost") {
            window.open('http://localhost:4000/api/assets/gl_form.docx', '_blank');
        } else if (dns === "192.168.100.23") {
            window.open('http://192.168.100.23:3005/api/assets/gl_form.docx', '_blank');
        } else if (dns === "or-v3.prasmul-eli.co") {
            window.open(`https://or-v3.prasmul-eli.co/api/assets/gl_form.docx`, '_blank');
        } else {
            window.open(`https://registration.prasmul-eli.co/api/assets/gl_form.docx`, '_blank');
        }
    }

    return (
        <>
            <div className='col-lg-12' style={{ marginBottom: '2%' }}>
                {
                    size.width < 500 ?
                        <h5>Konfirmasi Pembayaran</h5>
                        :
                        <h3>Konfirmasi Pembayaran</h3>
                }
                <hr style={{ marginBottom: '2%', marginTop: '2%' }}></hr>
                <div className='row mb-3'>
                    <p style={{ fontSize: size.width < 500 ? '12px' : '16px', marginBottom: '2%' }}>Silahkan <b>pilih salah satu</b> untuk proses pembayaran !</p>
                </div>
                <div className='row mb-3'>
                    <table border={1}>
                        <nav className="nav nav-pills d-flex justify-content-around" style={{ margin: '5px' }}>
                            <span onClick={(e) => handleMetodePembayaran('gl')} type='button' className={metodePembayaranSelected.value === 'gl' ? 'btn btn-primary' : 'btn btn-ghost-primary'} style={{ fontWeight: '600' }}>Guarantee Letter</span>
                            <span onClick={(e) => handleMetodePembayaran('non-gl')} type='button' className={metodePembayaranSelected.value === 'non-gl' ? 'btn btn-primary' : 'btn btn-ghost-primary'} style={{ fontWeight: '600' }}>Bukti Pembayaran</span>
                        </nav>
                    </table>
                    {
                        metodePembayaranSelected.value === 'gl' ?
                            <div className='col-lg-12' style={{ marginTop: '2%' }}>
                                <Card
                                    bg='warning'
                                    key='Warning'
                                    text='dark'
                                    style={{ marginBottom: '2%' }}
                                >
                                    <Card.Body style={{ backgroundColor: '#FFEFDD' }}>
                                        <div className='row'>
                                            {
                                                size.width < 500 ?
                                                    ''
                                                    :
                                                    <div className='col-lg-1 col-12'>
                                                        <br></br>
                                                        <IconInfoCircleFilled
                                                            width="65px" height="65px"
                                                            className='text-warning'
                                                        />
                                                    </div>
                                            }

                                            <div className='col-lg-11 col-12'>
                                                <Card.Title style={{ fontWeight: '600', fontSize: size.width < 500 ? '12px' : '14px' }} className='text-warning'>Cara Upload Guarantee Letter</Card.Title>
                                                <Card.Text style={{ fontSize: size.width < 500 ? '12px' : '14px' }}>
                                                    <p style={{ marginBottom: '0' }}>1. Silahkan Download Template Guarantee Letter disini (<b type="button" onClick={() => handleShowGl()}>Download Template</b>)</p>
                                                    <p style={{ marginBottom: '0' }}>2. Lengkapi form yang ada pada dokumen</p>
                                                    <p style={{ marginBottom: '0' }}>3. Kemudian Upload Guarantee Letter anda disini!</p>
                                                </Card.Text>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>

                                <label htmlFor='uploadGl' className="form-label mb-3">Upload Guarantee Letter</label>

                                <Card style={{ backgroundColor: '#B6DAF4', padding: '2%' }}>

                                    <Dropzone onDrop={handleDrop}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section type='button'>
                                                <div {...getRootProps()}>
                                                    <input {...getInputProps()} />
                                                    <div className='row'>
                                                        <div className='col-lg-2 col-12'>
                                                            <IconFileUpload
                                                                width="65px" height="65px"
                                                                className='text-primary'
                                                            />
                                                        </div>
                                                        <div className='col-lg-10 col-12'>
                                                            <p style={{ fontSize: size.width < 500 ? '12px' : '16px', fontWeight: '600', marginBottom: '1%' }}>Drop file disini atau klik untuk upload file</p>
                                                            <p style={{ fontSize: size.width < 500 ? '12px' : '16px', color: '#5E6278' }}>Upload 1 file</p>
                                                            {
                                                                dataInputRegistration.fileGLDanBuktiBayar ?
                                                                    <div className='mb-3' style={{ fontStyle: 'italic', fontWeight: '500' }}>{dataInputRegistration.fileGLDanBuktiBayar && `${dataInputRegistration.fileGLDanBuktiBayar.name} - ${dataInputRegistration.fileGLDanBuktiBayar.type}`}</div>
                                                                    :
                                                                    ''
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>

                                </Card>
                                <p style={{ marginTop: '2%' }}>Format File .PDF</p>
                            </div>
                            :
                            <div className='col-lg-12' style={{ marginTop: '2%' }}>
                                <Card
                                    bg='warning'
                                    key='Warning'
                                    text='dark'
                                    style={{ marginBottom: '2%' }}
                                >
                                    <Card.Body style={{ backgroundColor: '#FFEFDD' }}>
                                        <div className='row'>
                                            {
                                                size.width < 500 ?
                                                    ''
                                                    :
                                                    <div className='col-lg-1 col-12'>
                                                        <br></br>
                                                        <IconInfoCircleFilled
                                                            width="65px" height="65px"
                                                            className='text-warning'
                                                        />
                                                    </div>
                                            }
                                            <div className='col-lg-11'>
                                                <Card.Title style={{ fontWeight: '600', fontSize: size.width < 500 ? '12px' : '14px' }} className='text-warning'>Cara Upload Bukti Pembayaran</Card.Title>
                                                <Card.Text style={{ fontSize: size.width < 500 ? '12px' : '14px' }}>
                                                    <p style={{ marginBottom: '0' }}>1. Silahkan melakukan pembayaran dengan transfer ke Rekening Bank kami: <br></br> &nbsp;&nbsp;&nbsp;<b>(BCA) 4976700988</b> A/N <b>PT Prasetiya Mulya ELI</b></p>
                                                    <p style={{ marginBottom: '0' }}>2. Simpan notifikasi / struk transaksi sebagai bukti  pembayaran</p>
                                                    <p style={{ marginBottom: '0' }}>3. Upload Bukti Pembayaran Anda disini</p>
                                                </Card.Text>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>

                                <label htmlFor='uploadBuktiBayar' className="form-label mb-3">Upload Bukti Bayar</label>

                                <Card style={{ backgroundColor: '#B6DAF4', padding: '2%' }}>
                                    <Dropzone onDrop={handleDrop}>
                                        {({ getRootProps, getInputProps }) => (
                                            <section type='button'>
                                                <div {...getRootProps()}>
                                                    <input {...getInputProps()} />
                                                    <div className='row'>
                                                        <div className='col-lg-2 col-12'>
                                                            <IconFileUpload
                                                                width="65px" height="65px"
                                                                className='text-primary'
                                                            />
                                                        </div>
                                                        <div className='col-lg-10 col-12'>
                                                            <p style={{ fontSize: size.width < 500 ? '12px' : '16px', fontWeight: '600', marginBottom: '1%' }}>Drop file disini atau klik untuk upload file</p>
                                                            <p style={{ fontSize: size.width < 500 ? '12px' : '16px', color: '#5E6278' }}>Upload 1 file</p>
                                                            {
                                                                dataInputRegistration.fileGLDanBuktiBayar ?
                                                                    <div className='mb-3' style={{ fontStyle: 'italic', fontWeight: '500' }}>{dataInputRegistration.fileGLDanBuktiBayar && `${dataInputRegistration.fileGLDanBuktiBayar.name} - ${dataInputRegistration.fileGLDanBuktiBayar.type}`}</div>
                                                                    :
                                                                    ''
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                </Card>
                            </div>
                    }
                </div>
            </div>
        </>
    )
}

export default RegistrationPageSixComp
